export default {
  'nav.poti': 'Sentieri',
  'nav.izhodisca': 'Punti di Partenza',
  'nav.galerija': 'Galleria',
  'nav.vreme': 'Meteo',
  'nav.o_nas': 'Chi Siamo',
  'nav.zacni_pot': 'Inizia il Sentiero',
  'nav.odpri_meni': 'Apri menu',
  'nav.zapri_meni': 'Chiudi menu',
  'nav.preskoci': 'Vai al contenuto',

  'hero.badge': 'Associazione Turistica STEZA — Šmarna Gora',
  'hero.title': 'POT NA PESKE',
  'hero.subtitle': 'ŠMARNA GORA',
  'hero.desc': 'Uno dei sentieri più belli, vari e accoglienti per visitatori di tutte le generazioni.',
  'hero.cta_start': 'Inizia il Sentiero',
  'hero.cta_explore': 'Esplora i Sentieri',
  'hero.cta_activities': 'Attività',
  'hero.scroll': 'Scorri',

  'intro.badge': 'Benvenuti',
  'intro.title': 'Šmarna Gora, la collina più amata di Lubiana',
  'intro.desc': 'Šmarna Gora, la collina più popolare vicino a Lubiana, offre numerosi sentieri per escursionisti, runner e amanti della natura.',
  'intro.highlight': 'Il Sentiero Peske è considerato uno dei percorsi più belli, vari e accoglienti per visitatori di ogni età.',
  'intro.pot_label': 'Sentiero Peske',
  'intro.route': 'Spodnje Pirniče → Šmarna Gora',

  'activities.badge': 'Attività',
  'activities.title': 'ESPLORARE ŠMARNA GORA',
  'activities.hiking.title': 'Escursionismo sulla Šmarna Gora',
  'activities.hiking.desc': 'Scoprite vari sentieri, dalle passeggiate facili alle salite più impegnative.',
  'activities.cycling.title': 'Ciclismo intorno alla Šmarna Gora',
  'activities.cycling.desc': 'Esplorate percorsi ciclabili panoramici nei dintorni con viste mozzafiato.',
  'activities.running.title': 'Trail Running sulla Šmarna Gora',
  'activities.running.desc': 'Una destinazione popolare per i trail runner — terreno vario con pendenza ideale.',
  'activities.running_around.title': 'Corsa intorno alla Šmarna Gora',
  'activities.running_around.desc': 'Anelli di corsa pianeggianti e dolci alla base, ideali per l\'allenamento ricreativo.',
  'activities.walks.title': 'Passeggiate ai piedi della Šmarna Gora',
  'activities.walks.desc': 'Passeggiate tranquille tra prati e sentieri boschivi, ideali per le famiglie.',

  'access.badge': 'Punto di Partenza',
  'access.title': 'PUNTO DI PARTENZA E ACCESSO',
  'access.desc': 'Il sentiero inizia presso il parcheggio LIPA a Spodnje Pirniče. L\'accesso è semplice — in auto o in autobus.',
  'access.start_label': 'Punto di Partenza del Sentiero',
  'access.address': 'Spodnje Pirniče 56',
  'access.parking_name': 'Parcheggio LIPA',
  'access.parking': 'Parcheggio',
  'access.free': 'Gratuito',
  'access.bus': 'Autobus',
  'access.bus_line': 'Linea 25',
  'access.info1': 'Parcheggiate il vostro veicolo al parcheggio LIPA o arrivate con l\'autobus numero 25 direttamente al punto di partenza davanti al ristorante con una splendida terrazza, dove potrete gustare una bevanda rinfrescante o uno spuntino prima di iniziare l\'escursione.',
  'access.info2': 'All\'inizio, un sentiero stretto coperto di trucioli di legno vi conduce oltre un prato verso il bosco, dove inizia la salita.',

  // ── PARKING ──
  'parking.hero_title': 'Parcheggio LIPA — Punto di partenza ufficiale',
  'parking.hero_subtitle': 'Spodnje Pirniče 56, 1211 Lubiana-Šmartno. Parcheggio gratuito proprio all\'inizio del sentiero Pot na Peske.',
  'parking.highlight_badge': '⭐ Punto di partenza ufficiale',
  'parking.section_title': 'PARCHEGGIO & ACCESSO',
  'parking.intro': 'Il parcheggio LIPA è il punto di partenza ufficiale, gratuito e più comodo per Pot na Peske — il nostro sentiero più bello per Šmarna gora.',
  'parking.address_label': 'Indirizzo',
  'parking.address_value': 'Spodnje Pirniče 56, 1211 Lubiana-Šmartno, Slovenia',
  'parking.gps_label': 'Coordinate GPS',
  'parking.gps_value': '46.1176° N, 14.4544° E',
  'parking.what3words': 'what3words',
  'parking.what3words_value': '///vzpon.pesek.lipa',
  'parking.capacity_label': 'Capacità',
  'parking.capacity_value': 'Gratuito, spazio per 20+ veicoli',
  'parking.type_label': 'Tipo di parcheggio',
  'parking.type_value': 'Parcheggio sterrato aperto',
  'parking.hours_label': 'Aperto',
  'parking.hours_value': '24/7 — tutto l\'anno',
  'parking.bus_info_title': 'Trasporto pubblico',
  'parking.bus_info': 'La linea bus LPP 25 arriva direttamente alla fermata davanti al parcheggio. La corsa dal centro di Lubiana dura circa 30 minuti.',
  'parking.facilities_title': 'Servizi',
  'parking.facility_gostilna': 'Ristorante con splendida terrazza proprio accanto al parcheggio',
  'parking.facility_wc': 'WC disponibile presso il ristorante',
  'parking.facility_info': 'Pannello informativo all\'inizio del sentiero Pot na Peske',
  'parking.facility_sign': 'Segnaletica STEZA / Pot na Peske',
  'parking.tips_title': 'Consigli per il parcheggio',
  'parking.tip1': 'Nei weekend e nei giorni festivi il parcheggio si riempie rapidamente — arrivate presto (prima delle 8).',
  'parking.tip2': 'Il parcheggio è sterrato — in inverno fate attenzione al possibile ghiaccio.',
  'parking.tip3': 'Non lasciate oggetti di valore in auto. Parcheggiate a vostro rischio.',
  'parking.tip4': 'Parcheggio aggiuntivo disponibile presso Gostilna Ledinek a Tacen (5 min in auto) se LIPA è pieno.',
  'parking.map_title': 'Posizione sulla mappa',
  'parking.cta_title': 'Pronti per Pot na Peske?',
  'parking.cta_subtitle': 'Parcheggiate al LIPA e partite per il sentiero più bello verso Šmarna gora.',
  'parking.cta_btn': 'Inizia il sentiero',
  'parking.cta_routes': 'Tutti i sentieri',

  'story.badge': 'Sentiero Peske',
  'story.title': 'DALLA PARTENZA ALLA VETTA',
  'story.subtitle': 'Un viaggio cinematografico attraverso ogni tappa del sentiero',
  'story.etapa': 'Tappa',
  'story.blocks.0.title': 'Inizio Dolce',
  'story.blocks.0.text': 'Iniziamo con una salita dolce su un sentiero comodo e largo, parzialmente coperto da rocce e radici. Presto svoltiamo su un sentiero sempre più stretto che sale un po\' più ripidamente.',
  'story.blocks.0.terrain': 'Sentiero largo, rocce, radici',
  'story.blocks.1.title': 'Tratto Più Dinamico',
  'story.blocks.1.text': 'Camminiamo su un terreno sempre più sabbioso, su rocce e radici, in parte attraverso un canalone relativamente profondo. Questa è la parte più ripida ma anche la più varia del sentiero.',
  'story.blocks.1.terrain': 'Terreno sabbioso, rocce, canalone',
  'story.blocks.2.title': 'Strada Sterrata',
  'story.blocks.2.text': 'Quando il sentiero si allarga e si appiattisce, raggiungiamo presto un\'ampia strada sterrata, la via carrabile per la Šmarna Gora proveniente da Zavrh.',
  'story.blocks.2.terrain': 'Sterrato, sentiero largo',
  'story.blocks.3.title': 'Monumento Turco',
  'story.blocks.3.text': 'Qui un segnavia ci indirizza a destra, oltre il Monumento della Peste o Turco, che ricorda i tempi delle invasioni ottomane.',
  'story.blocks.3.terrain': 'Segnavia, punto storico',
  'story.blocks.4.title': 'Cappella Gorjanc',
  'story.blocks.4.text': 'La strada sale dolcemente attraverso il bosco, che gradualmente si apre. A sinistra si trova la Cappella Gorjanc, dove è conservata l\'usanza di deporre piccole croci.',
  'story.blocks.4.terrain': 'Strada forestale, cappella',
  'story.blocks.5.title': 'Spodnji Gorjanc — Incrocio',
  'story.blocks.5.text': 'Arriviamo a Spodnji Gorjanc, un importante incrocio di sentieri. Qui si intersecano i percorsi verso Grmada, il Sentiero delle Radici (verso Tacen) e la continuazione verso la Šmarna Gora.',
  'story.blocks.5.terrain': 'Incrocio sentieri, Grmada, Sentiero delle Radici',
  'story.blocks.6.title': 'Vista sulle Alpi',
  'story.blocks.6.text': 'Proseguiamo attraverso prati da pascolo, dove si aprono viste sulle Alpi di Kamnik-Savinja e sulle Alpi Giulie con il Triglav.',
  'story.blocks.6.terrain': 'Prati da pascolo, viste panoramiche',
  'story.blocks.7.title': 'Sedlo — Incrocio con Grmada',
  'story.blocks.7.text': 'A Sedlo (Sella), il sentiero incrocia il percorso per Grmada e si unisce ai sentieri da Tacen, Šmartno e Vikrče. Da qui si può scegliere il percorso sterrato più facile o un sentiero più stretto e roccioso oltre la Cappella di Santa Sobota.',
  'story.blocks.7.terrain': 'Sella, incrocio Grmada–Šmarna Gora, due opzioni',
  'story.blocks.8.title': 'Vetta — Scelta del Percorso',
  'story.blocks.8.text': 'Consigliamo la salita più ripida e la discesa più dolce. In questo modo sperimentate entrambi i lati della Šmarna Gora e godete dell\'esperienza completa.',
  'story.blocks.8.terrain': 'Due percorsi, salita e discesa',

  'highlight.title': 'Uno dei sentieri più accoglienti sulla Šmarna Gora',
  'highlight.text1': 'Questo è anche uno dei sentieri più accoglienti sulla Šmarna Gora — mai esposto, senza grandi pendenze e piacevole da percorrere anche dopo la pioggia quando molti altri sentieri sono fangosi.',
  'highlight.text2': 'La prima sezione è molto varia e quindi estremamente popolare tra escursionisti, runner e famiglie.',

  'viewpoint.badge': 'Panorama',
  'viewpoint.title': 'VISTE DALLA VETTA',
  'viewpoint.desc': 'Sulla vetta della Šmarna Gora, prendetevi del tempo nelle giornate limpide per godere delle magnifiche viste su Lubiana, il fiume Sava, le colline circostanti e le Alpi. La cima con la sua chiesa pittoresca offre uno dei panorami più belli della Slovenia centrale.',

  'gallery.badge': 'Galleria',
  'gallery.title': 'Šmarna Gora attraverso l\'obiettivo',
  'gallery.subtitle': 'Momenti che danno vita allo spirito della montagna — ogni fotografia racconta la propria storia',
  'gallery.enlarge': 'Ingrandisci',
  'gallery.close': 'Chiudi anteprima',
  'gallery.prev': 'Immagine precedente',
  'gallery.next': 'Immagine successiva',
  'gallery.open': 'Apri immagine',

  'weather.badge': 'Meteo in Tempo Reale',
  'weather.title': 'METEO SULLA ŠMARNA GORA',
  'weather.loading': 'Aggiornamento...',
  'weather.updated': 'Ultimo aggiornamento',
  'weather.current': 'Attuale',
  'weather.feels_like': 'Percepito',
  'weather.wind': 'Vento',
  'weather.humidity': 'Umidità',
  'weather.visibility': 'Visibilità',
  'weather.cloud_cover': 'Nuvolosità',
  'weather.uv_index': 'Indice UV',
  'weather.rain': 'Pioggia',
  'weather.hiking_score': 'Punteggio Escursione',
  'weather.out_of': 'su 100 punti',
  'weather.trail_safety': 'Sicurezza del Sentiero',
  'weather.safety_optimal': 'Condizioni Sicure',
  'weather.safety_caution': 'Prestare Attenzione',
  'weather.safety_warning': 'Condizioni Difficili',
  'weather.safety_danger': 'Condizioni Pericolose',
  'weather.no_alerts': 'Nessun avviso particolare',
  'weather.best_time': 'Orario Migliore per Escursione',
  'weather.next_hours': 'Prossime Ore',
  'weather.seven_day': 'Previsioni 7 Giorni',
  'weather.disclaimer': 'I dati sono solo a scopo informativo. Controllate sempre le previsioni meteo ufficiali prima dell\'escursione. Fonte: Open-Meteo API.',
  'weather.error_load': 'Impossibile caricare i dati meteo',
  'weather.error_stale': 'Visualizzazione ultimi dati salvati',
  'weather.smarna_elevation': 'Šmarna Gora, 669m',

  'safety.badge': 'Importante',
  'safety.title': 'SICUREZZA SUL SENTIERO',
  'safety.slippery_title': 'Superficie Scivolosa',
  'safety.slippery_desc': 'Dopo la pioggia, radici e rocce diventano estremamente scivolose. Indossate scarponi da trekking con una buona presa. Evitate scorciatoie su terreno bagnato.',
  'safety.winter_title': 'Condizioni Invernali',
  'safety.winter_desc': 'In inverno, i sentieri possono essere ghiacciati. L\'attrezzatura invernale è essenziale: ramponi, bastoncini da trekking. Controllate il meteo prima della partenza.',
  'safety.sunset_title': 'Alba / Tramonto',
  'safety.sunset_desc': 'Se partite per l\'alba o il tramonto, portate sempre una lampada frontale. Dite sempre a qualcuno la vostra destinazione.',
  'safety.emergency_title': 'Emergenza',
  'safety.emergency_desc': 'In caso di emergenza, chiamate il 112. L\'app del Soccorso Alpino consente una rapida localizzazione. Salvate il numero prima dell\'escursione.',
  'safety.warning_title': 'AVVERTENZA',
  'safety.warning_text': 'Le informazioni su questa pagina sono solo a scopo informativo. Le escursioni sono intraprese a proprio rischio. Prima di ogni escursione, controllate le condizioni meteorologiche, assicuratevi di avere l\'attrezzatura adeguata e valutate la vostra forma fisica. STEZA non si assume alcuna responsabilità per eventuali infortuni o incidenti.',

  'facebook.badge': 'Comunità',
  'facebook.title': 'UNISCITI A NOI',
  'facebook.desc': 'Segui STEZA.SI su Facebook per le ultime notizie, eventi e foto',
  'facebook.label': 'Comunità Facebook',

  'webcam.badge': 'In Diretta',
  'webcam.title': 'WEBCAM ŠMARNA GORA',
  'webcam.desc': 'Vista in diretta dalla vetta della Šmarna Gora — presto disponibile',
  'webcam.coming_soon': 'Webcam presto disponibile',
  'webcam.preparing': 'Stiamo preparando una trasmissione in diretta dalla vetta della Šmarna Gora. Grazie per la pazienza.',
  'webcam.status': 'In preparazione',

  'media.badge': 'Media',
  'media.title': 'GALLERIA & VIDEO',
  'media.desc': 'Riprese cinematografiche e fotografia della Šmarna Gora — presto disponibili',
  'media.drone': 'VIDEO DRONE IN PRODUZIONE',
  'media.drone_desc': 'Ripresa cinematografica del Sentiero Peske',
  'media.views': 'Viste',
  'media.trail': 'Sentiero',
  'media.history': 'Storia',

  'footer.desc': 'Il Sentiero Peske — Šmarna Gora. Associazione Turistica STEZA. Un\'esperienza escursionistica premium con informazioni professionali su sentieri, meteo e sicurezza.',
  'footer.newsletter_title': 'Ricevi Aggiornamenti sui Sentieri',
  'footer.newsletter_success': 'Grazie! Sei iscritto alle notizie STEZA.',
  'footer.newsletter_placeholder': 'Inserisci la tua email',
  'footer.newsletter_btn': 'Iscriviti',
  'footer.trails': 'Sentieri',
  'footer.platform': 'Piattaforma',
  'footer.legal': 'Legale',
  'footer.pot_peske': 'Sentiero Peske',
  'footer.pot_korenine': 'Sentiero delle Radici',
  'footer.mazijeva': 'Sentiero Mazi',
  'footer.romarska': 'Sentiero del Pellegrino',
  'footer.plezalna': 'Via Ferrata',
  'footer.izhodisca': 'Punti di Partenza',
  'footer.galerija': 'Galleria',
  'footer.vreme': 'Meteo',
  'footer.o_stezi': 'Chi è STEZA',
  'footer.kontakt': 'Contatti',
  'footer.privacy': 'Informativa sulla Privacy',
  'footer.cookies': 'Cookie',
  'footer.disclaimer': 'Esclusione di Responsabilità',
  'footer.safety_notice': 'Avviso di Sicurezza',
  'footer.copyright': '© 2026 STEZA.SI — Associazione Turistica STEZA, Šmarna Gora',
  'footer.disclaimer_text': 'Avviso importante: Le informazioni su questo sito sono solo a scopo informativo. Le escursioni e le attività all\'aperto sono intraprese a proprio rischio. Controllate le condizioni meteorologiche, l\'attrezzatura adeguata e lo stato dei sentieri prima della visita.',
  'footer.facebook_label': 'STEZA su Facebook',
  'footer.instagram_label': 'STEZA su Instagram',

  'about.hero_title': 'Chi è STEZA',
  'about.hero_subtitle': 'Una piattaforma escursionistica premium, creata con amore per la Šmarna Gora.',
  'about.story_badge': 'La Nostra Storia',
  'about.story_title': 'Il sentiero più bello sulla Šmarna Gora',
  'about.story_p1': 'STEZA è nata da un\'idea semplice: un\'escursione sulla Šmarna Gora può essere più di una semplice ricreazione — può essere un\'esperienza. Abbiamo creato una piattaforma che unisce informazioni escursionistiche professionali a un\'estetica eccezionale e alla tecnologia moderna.',
  'about.story_p2': 'Siamo un team di escursionisti, fotografi e designer che credono che ogni montagna meriti la propria presentazione premium. La Šmarna Gora non è solo una collina — è un simbolo di Lubiana, una meta di pellegrinaggio, un gioiello naturale e un\'arena sportiva tutto in uno.',
  'about.story_p3': 'STEZA non è un portale turistico. Non è un blog. È una piattaforma escursionistica cinematografica premium per chiunque voglia scoprire la Šmarna Gora in modo diverso.',
  'about.elevation_label': 'Šmarna Gora',
  'about.elevation': '669 m s.l.m.',
  'about.how_title': 'Come è Nata STEZA',
  'about.how_p1': 'La storia è iniziata sulla vetta della Šmarna Gora. Eravamo sulla piattaforma panoramica, guardavamo verso le Alpi e ci chiedevamo: perché una collina così bella non ha una presenza online moderna, chiara e bella? Tutto ciò che abbiamo trovato erano post sparsi nei forum, blog obsoleti e foto di bassa qualità. Fu allora che decidemmo — avremmo creato qualcosa di diverso.',
  'about.how_p2': 'Abbiamo trascorso i successivi sei mesi sul campo. Abbiamo percorso ogni sentiero — dal più facile al più impegnativo. Abbiamo fotografato albe, foreste piovose, cime innevate e tramonti dorati. Abbiamo parlato con guide locali, ristoratori, escursionisti esperti e visitatori alle prime armi. Volevamo capire la Šmarna Gora da ogni angolazione.',
  'about.how_p3': 'STEZA non è solo un sito web. È un diario visivo del nostro amore per questa montagna. Ogni fotografia è scattata professionalmente, ogni sentiero percorso personalmente, ogni dato verificato. Crediamo che la Šmarna Gora — come una delle mete escursionistiche più visitate della Slovenia — meriti una presentazione di livello mondiale.',
  'about.how_p4': 'Abbiamo tratto ispirazione dal design di marchi outdoor premium come Patagonia, The North Face e National Geographic Travel. Volevamo creare una piattaforma che respiri avventura pur rimanendo minimalista, pulita e professionale.',
  'about.how_p5': 'Oggi STEZA copre quattro sentieri principali per la Šmarna Gora, dati meteo in tempo reale, navigazione GPS, linee guida di sicurezza e una ricca galleria. Ma questo è solo l\'inizio. La nostra visione è diventare la migliore piattaforma escursionistica in Slovenia — e la Šmarna Gora è il nostro primo, più caro progetto.',
  'about.gora_badge': 'Scopri la Montagna',
  'about.gora_title': 'Šmarna Gora — il cuore della nostra storia',
  'about.gora_subtitle': '669 metri che uniscono le generazioni',
  'about.gora_p1': 'La Šmarna Gora (669 m) è la vetta escursionistica più popolare della Slovenia centrale. Si trova a soli 10 chilometri a nord-ovest di Lubiana, ma nonostante la vicinanza alla città, offre un contatto autentico con la natura, una ricca storia e panorami mozzafiato.',
  'about.gora_p2': 'È un inselberg — una collina che geologicamente non appartiene a nessuna catena montuosa più grande, ma si eleva indipendentemente sopra il Bacino di Lubiana. Composta da calcare e dolomia, i suoi pendii meridionali sono noti per specie vegetali termofile.',
  'about.gora_p3': 'Nel corso dei secoli, la Šmarna Gora è stata tutto: un insediamento preistorico, un punto strategico con il Castello di Šumberk, una meta di pellegrinaggio, una popolare destinazione escursionistica per i cittadini, e oggi è parte indispensabile dell\'identità sportiva e culturale di Lubiana.',
  'about.history_title': 'Storia Scolpita nella Pietra',
  'about.history_bronze_date': '1500 a.C.',
  'about.history_bronze_title': 'Età del Bronzo',
  'about.history_bronze_text': 'I reperti archeologici sulla vetta testimoniano un insediamento preistorico. Ceramiche, utensili e resti di abitazioni indicano un\'occupazione permanente durante l\'Età del Bronzo.',
  'about.history_castle_date': 'XII–XIII sec.',
  'about.history_castle_title': 'Castello di Šumberk',
  'about.history_castle_text': 'Il castello medievale di Šumberk (Schönberg) sorgeva un tempo sulla vetta. Oggi rimangono solo modeste tracce archeologiche e leggende di cavalieri.',
  'about.history_church_date': '1711',
  'about.history_church_title': 'Chiesa della Madre di Dio',
  'about.history_church_text': 'Una chiesa barocca fu costruita sul sito di una precedente chiesa gotica del XIV secolo. Divenne la meta di pellegrinaggio centrale della Slovenia centrale.',
  'about.history_modern_date': 'XIX sec.–oggi',
  'about.history_modern_title': 'Meta Alpina',
  'about.history_modern_text': 'Con lo sviluppo dell\'alpinismo, divenne la meta escursionistica più popolare per gli abitanti di Lubiana. Mantiene questo status ancora oggi con oltre 500.000 visitatori all\'anno.',
  'about.nature_title': 'Natura che Ispira',
  'about.nature_p1': 'I pendii meridionali della Šmarna Gora sono un paradiso botanico. Il microclima caldo favorisce piante che si trovano normalmente molto più a sud: l\'elleboro nero fiorisce già a febbraio, seguito dall\'iris profumato, dalla pulsatilla comune e dal colchico autunnale.',
  'about.nature_p2': 'Le foreste sono miste — dominano faggio, quercia e abete rosso, con un magnifico castagno sulla vetta. La fauna include cervi, volpi, cinghiali, tassi, scoiattoli e ghiri.',
  'about.nature_p3': 'Promuoviamo un escursionismo responsabile — non lasciare tracce, non raccogliere piante, non disturbare la fauna e porta i rifiuti a valle.',
  'about.legends_title': 'Leggende che Vivono',
  'about.legend_bell_title': 'La Campana dei Desideri',
  'about.legend_bell_text': 'La leggenda più famosa della Šmarna Gora. Se suoni la campana tre volte — la prima per la salute, la seconda per la fortuna e la terza per l\'amore — esprimendo un desiderio a ogni rintocco, il tuo desiderio si avvererà.',
  'about.legend_castle_title': 'Il Castello di Šumberk e il Tesoro',
  'about.legend_castle_text': 'La leggenda narra che i cavalieri del Castello di Šumberk, prima di partire per le Crociate, seppellirono un tesoro d\'oro da qualche parte sui pendii della Šmarna Gora. Non è mai stato trovato.',
  'about.legend_mary_title': 'L\'Apparizione di Maria',
  'about.legend_mary_text': 'Secondo la tradizione popolare, la Vergine Maria apparve sulla cima della collina, dando il nome alla montagna. Questa tradizione portò alla costruzione della chiesa e a una tradizione di pellegrinaggio che dura da oltre 300 anni.',
  'about.stats_title': 'STEZA in Numeri',
  'about.values_title': 'I Nostri Valori',
  'about.values.professionalism': 'Professionalità',
  'about.values.professionalism_text': 'Tutte le informazioni sono attentamente verificate e regolarmente aggiornate. Collaboriamo con guide locali e il Soccorso Alpino.',
  'about.values.aesthetics': 'Estetica',
  'about.values.aesthetics_text': 'Crediamo che immagini belle siano fondamentali per l\'ispirazione. Ogni fotografia sul sito è scattata e curata professionalmente.',
  'about.values.safety': 'Sicurezza',
  'about.values.safety_text': 'La sicurezza viene prima di tutto. Ogni sentiero include avvertenze dettagliate, attrezzatura consigliata e linee guida di sicurezza.',
  'about.values.passion': 'Passione',
  'about.values.passion_text': 'STEZA è un progetto nato dalla passione. Ogni membro del team è un escursionista che conosce personalmente ogni sentiero della Šmarna Gora.',
  'about.values.sustainability': 'Sostenibilità',
  'about.values.sustainability_text': 'Promuoviamo un escursionismo responsabile. Non lasciare tracce, rispetta la natura e la fauna, porta i rifiuti con te.',
  'about.values.community': 'Comunità',
  'about.values.community_text': 'Stiamo costruendo una comunità di escursionisti che condividono esperienze e si aiutano a vicenda nella scoperta della Šmarna Gora.',
  'about.cta_title': 'Unisciti a STEZA',
  'about.cta_subtitle': 'Ogni sentiero ha una storia. Scoprila con noi.',
  'about.cta_explore': 'Esplora i Sentieri',
  'about.cta_contact': 'Contattaci',

  'contact.hero_title': 'Contatti',
  'contact.hero_subtitle': 'Hai una domanda, un suggerimento o desideri collaborare? Scrivici o chiamaci.',
  'contact.write_us': 'Scrivici',
  'contact.email_label': 'Email',
  'contact.phone_label': 'Telefono',
  'contact.location_label': 'Posizione',
  'contact.location_value': 'Šmarna Gora, 1211 Lubiana-Šmartno, Slovenia',
  'contact.follow_us': 'Seguici',
  'contact.success_title': 'Grazie per il tuo messaggio!',
  'contact.success_text': 'Ti risponderemo il prima possibile.',
  'contact.name_label': 'Nome',
  'contact.name_placeholder': 'Il tuo nome',
  'contact.email_placeholder': 'tua@email.it',
  'contact.message_label': 'Messaggio',
  'contact.message_placeholder': 'Il tuo messaggio (max 500 caratteri)',
  'contact.submit': 'Invia Messaggio',
  'contact.error_fields': 'Si prega di compilare tutti i campi.',
  'contact.error_length': 'Messaggio troppo lungo. Massimo 500 caratteri.',
  'contact.error_general': 'Si è verificato un errore. Riprova.',

  'routes.hero_title': 'Sentieri',
  'routes.hero_subtitle': 'Cinque sentieri unici verso la vetta della Šmarna Gora. Dal facile Sentiero Peske alle impegnative vie ferrate — scegli la tua STEZA.',
  'routes.explore': 'Esplora il Sentiero',
  'routes.compare_title': 'Confronto dei Sentieri',
  'routes.table_pot': 'Sentiero',
  'routes.table_tezavnost': 'Difficoltà',
  'routes.table_trajanje': 'Durata',
  'routes.table_visinska': 'Dislivello',
  'routes.table_dolzina': 'Lunghezza',
  'routes.table_tip': 'Tipo',
  'routes.cta_title': 'Pronto per la tua STEZA?',
  'routes.cta_subtitle': 'Scegli il sentiero più adatto a te e scopri la Šmarna Gora in un modo che ricorderai.',
  'routes.cta_find': 'Trova Punto di Partenza',
  'routes.cta_weather': 'Controlla Meteo',
  'routes.difficulty_easy': 'Facile',
  'routes.difficulty_moderate': 'Moderato',
  'routes.difficulty_hard': 'Difficile',

  'gallery_page.badge': 'Collezione Fotografica',
  'gallery_page.title': 'Galleria',
  'gallery_page.subtitle': 'Una collezione di fotografie della Šmarna Gora — sentieri, viste e momenti che condividiamo.',
  'gallery_page.section_trail_title': 'Il Percorso verso la Vetta',
  'gallery_page.section_trail_subtitle': 'Sentieri escursionistici attraverso il bosco e la natura durante la salita',
  'gallery_page.section_summit_title': 'La Vetta',
  'gallery_page.section_summit_subtitle': 'Viste, panorami e momenti sulla cima della Šmarna Gora',
  'gallery_page.section_parking_title': 'Parcheggio',
  'gallery_page.section_parking_subtitle': 'Accesso al punto di partenza e parcheggio in tutte le stagioni',
  'gallery_page.empty_title': 'La sezione {title} è pronta. Aggiungi immagini e appariranno qui.',
  'gallery_page.empty_subtitle': 'Sezione pronta.',
  'gallery_page.close': 'Chiudi galleria',
  'gallery_page.prev': 'Immagine precedente',
  'gallery_page.next': 'Immagine successiva',
  'gallery_page.open': 'Visualizza immagine',
  'gallery_page.cta_title': 'Scatta la Tua Foto',
  'gallery_page.cta_subtitle': 'Le foto più belle nascono sulla vetta. Condividi i tuoi scatti migliori con l\'hashtag #STEZA.',
  'gallery_page.cta_btn': 'Trova il Tuo Sentiero',

  'legal.not_found': 'Pagina non trovata',
  'legal.back_home': '← Torna alla home',
  'legal.updated': 'Ultimo aggiornamento',
  'legal.copyright': '© 2026 STEZA.SI — Tutti i diritti riservati. Contatto: info@steza.si',

  'notfound.title': 'Questa pagina non è stata ancora creata',
  'notfound.subtitle': 'Raccontami di più su questa pagina, così posso crearla',
  'notfound.back_home': 'Torna alla homepage',

  'lang.sl': 'Slovenščina',
  'lang.en': 'English',
  'lang.de': 'Deutsch',
  'lang.it': 'Italiano',
  'lang.hr': 'Hrvatski',
  'lang.es': 'Español',
  'lang.ru': 'Русский',

  'seo.home_title': 'Sentiero Peske — Šmarna Gora | STEZA — Piattaforma Escursionistica Premium',
  'seo.home_desc': 'Il Sentiero Peske è uno dei percorsi più belli per la Šmarna Gora. Un\'esperienza escursionistica premium con informazioni professionali su sentieri, meteo, sicurezza e punti panoramici. Associazione Turistica STEZA.',
  'seo.home_keywords': 'Sentiero Peske, Šmarna Gora, escursionismo Šmarna Gora, escursionismo Slovenia, sentieri Šmarna Gora, escursionismo Lubiana, alpinismo Slovenia',
  'seo.og_title': 'Sentiero Peske — Šmarna Gora | STEZA',
  'seo.og_desc': 'Piattaforma escursionistica premium per la Šmarna Gora. Scopri il Sentiero Peske — uno dei percorsi più belli e accoglienti per la Šmarna Gora.',
  'seo.schema_desc': 'Il Sentiero Peske è uno dei percorsi più belli per la Šmarna Gora. Associazione Turistica STEZA — una piattaforma escursionistica premium per la Šmarna Gora.',
};